<template>
  <v-container class="grey lighten-5">
    <h2
    class="accent--text text-center my-8 display-3">
      For Entrepreneurs Looking to go from $0 to $1mm
    </h2>
    <v-row no-gutters>
      <v-col
        v-for="(item, i) in items"
        :key="i"
        cols="12"
        sm="3"
      >
        <v-card
          class="pa-2 fill-height"
          outlined
          tile
          elevation="6"
        >
          <v-card-title>
            <h3 class="accent--text">{{ item.title }}</h3>
          </v-card-title>
          <v-card-text>
            {{ item.text }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  name: 'LandingDetails',

  data() {
    return {
      items: [
        {
          title: 'Free',
          text: 'Register and watch the entire conference for free!',
          color: 'red',
        },
        {
          title: 'Nevada Minded',
          text: 'Learn from entrepreneurs, service providers and government agencies',
          color: 'blue',
        },
        {
          title: '100% Online',
          text: 'Login, watch and answer questions live during the sessions',
          color: 'orange',
        },
        {
          title: 'Goal Guide',
          text: 'Get your companion guide to customize your experience',
          color: 'orange',
        },
      ],
    };
  },
};
</script>

<style lang="css" scoped>
  h3 {
    font-family: 'Permanent Marker', cursive;
  }
</style>
